import { lazy } from "react";

function GetLazyPage(importModule) {
	return lazy(() => {
		return Promise.all([
			importModule,
			new Promise((resolve) => setTimeout(resolve, 2000)),
		]).then(([moduleExports]) => moduleExports);
	});
}

export { GetLazyPage };
